import React from 'react';
import { Box, Grid } from '@mui/material';
import { LawsDatabase } from './components/LawsDatabase';
import { ComplianceDocuments } from './components/ComplianceDocuments';
import { AuditTrail } from './components/AuditTrail';

export const ComplianceCenter: React.FC = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        p: 2,
        height: '100%'
      }}
    >
      <Box 
        component="div" 
        sx={{ 
          typography: 'h4',
          fontWeight: 500
        }}
      >
        Compliance & Policy Center
      </Box>

      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: 'auto' }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <LawsDatabase />
          </Grid>
          <Grid item xs={12} md={4}>
            <ComplianceDocuments />
          </Grid>
          <Grid item xs={12}>
            <AuditTrail />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};